"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatwishlistInteraction = exports.formatPurchase = exports.formatProductView = exports.formatProductClick = exports.formatCheckout = void 0;
var _formatProduct = _interopRequireDefault(require("./formatProduct"));
var _createPaymentString = _interopRequireDefault(require("./createPaymentString"));
var _upropsCookieData2 = _interopRequireDefault(require("./upropsCookieData"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DELIVERY_PASS_ID = 'RIDP01';
var formatProductView = exports.formatProductView = function formatProductView(event) {
  if (!event.data[0].product || !event.context) {
    return event;
  }
  var list = localStorage.getItem('list');
  localStorage.setItem('list', '');
  var _event$context = event.context,
    currency = _event$context.currency,
    currencyCode = _event$context.currencyCode;
  var _event$data$0$product = event.data[0].product,
    name = _event$data$0$product.name,
    id = _event$data$0$product.id,
    category = _event$data$0$product.category,
    subCategory = _event$data$0$product.subCategory,
    listPrice = _event$data$0$product.listPrice,
    stockLevel = _event$data$0$product.stockLevel,
    colour = _event$data$0$product.colour,
    brands = _event$data$0$product.brands,
    division = _event$data$0$product.division,
    initialPrice = _event$data$0$product.initialPrice,
    isMarkedDown = _event$data$0$product.isMarkedDown,
    categories = _event$data$0$product.categories,
    images = _event$data$0$product.images,
    variantId = _event$data$0$product.variantId,
    affiliation = _event$data$0$product.affiliation,
    productDatePublished = _event$data$0$product.productDatePublished,
    videoOnPDP = _event$data$0$product.videoOnPDP;
  return {
    ecommerce: {
      currencyCode: currency || currencyCode,
      detail: {
        products: [_objectSpread(_objectSpread({
          name: name,
          id: id,
          category: category,
          subcategory: subCategory,
          price: listPrice,
          stock: stockLevel.toString(),
          colour: colour,
          division: division,
          initialPrice: initialPrice,
          isMarkedDown: isMarkedDown,
          categories: categories
        }, brands && {
          brands: brands
        }), {}, {
          images: images,
          variantId: variantId,
          affiliation: affiliation,
          productDatePublished: productDatePublished,
          videoOnPDP: videoOnPDP
        })],
        actionField: {
          list: list,
          type: event.data[0].type
        }
      }
    }
  };
};
var formatPurchase = exports.formatPurchase = function formatPurchase(event) {
  if (event.ecommerce) {
    return event;
  }
  if (!event.data[0].purchaseOrder || !event.context) {
    return event;
  }
  var purchaseOrder = event.data[0].purchaseOrder;
  var _event$context2 = event.context,
    currency = _event$context2.currency,
    currencyCode = _event$context2.currencyCode;
  var id = purchaseOrder.id,
    timestampLocal = purchaseOrder.timestampLocal,
    total = purchaseOrder.total,
    discounts = purchaseOrder.discounts,
    items = purchaseOrder.items,
    payments = purchaseOrder.payments,
    coupon = purchaseOrder.coupon;
  var repeatPurchaser = purchaseOrder.customer.repeatPurchaser;
  var _purchaseOrder$itemsT = purchaseOrder.itemsTotal,
    discountsAmount = _purchaseOrder$itemsT.discount,
    value = _purchaseOrder$itemsT.value;
  var shipping = purchaseOrder.deliveryTotal.value;
  var _purchaseOrder$delive = purchaseOrder.delivery,
    deliveryMethodName = _purchaseOrder$delive.deliveryMethodName,
    provider = _purchaseOrder$delive.provider,
    type = _purchaseOrder$delive.type;
  var lineItemProducts = items.filter(function (item) {
    return item.productId !== DELIVERY_PASS_ID;
  });
  var products = (0, _formatProduct["default"])(lineItemProducts);
  var paymentMethod = (0, _createPaymentString["default"])(payments);
  var isDiscountZero = parseFloat(discountsAmount) === 0;
  var hasNoDiscount = discounts.length === 0;
  var hasDeliveryPass = function hasDeliveryPass(element) {
    return element.productId === DELIVERY_PASS_ID;
  };
  var _upropsCookieData = (0, _upropsCookieData2["default"])(),
    deliveryPassStatus = _upropsCookieData.deliveryPassStatus;
  var totalValue;
  var revenueValue;
  var deliveryPassOrder;
  var deliveryPassPrice;
  if (items.some(hasDeliveryPass)) {
    deliveryPassOrder = true;
    var deliveryPassProduct = items.filter(function (item) {
      return item.productId === DELIVERY_PASS_ID;
    });
    var product = deliveryPassProduct[0].product;
    var listPrice = product.listPrice;
    var totalCalculation = parseInt(total, 10) - listPrice;
    totalValue = totalCalculation.toFixed(2);
    var revenueCalculation = parseInt(value, 10) - listPrice;
    revenueValue = revenueCalculation.toFixed(2);
    deliveryPassPrice = listPrice;
  } else {
    deliveryPassOrder = false;
    totalValue = total;
    revenueValue = value;
  }
  return {
    ecommerce: {
      currencyCode: currency || currencyCode,
      purchase: {
        actionField: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          id: id,
          currency: currency || currencyCode,
          currencyCode: currency || currencyCode,
          returning: repeatPurchaser,
          timestamp: timestampLocal.split('+')[0],
          paymentMethod: paymentMethod
        }, discounts.length > 0 && {
          discountList: discounts
        }), !hasNoDiscount && {
          discounts: [coupon.toLowerCase()]
        }), !isDiscountZero && {
          discountsAmount: discountsAmount
        }), {}, {
          shipping: shipping,
          shippingMethod: deliveryMethodName,
          deliveryProvider: provider,
          deliveryType: type,
          deliveryPassOrder: deliveryPassOrder
        }, deliveryPassPrice && {
          deliveryPassPrice: deliveryPassPrice
        }), {}, {
          revenue: revenueValue,
          total: totalValue
        }, deliveryPassStatus && {
          deliveryPassStatus: deliveryPassStatus
        }),
        products: products
      }
    }
  };
};
var transferStepToInteger = function transferStepToInteger(step, isGlobale) {
  var stepMap = {
    signinselection: 1,
    deliverytypeselection: 2,
    deliveryaddressselection: 3,
    deliveryoptionselection: 4,
    paymentselection: 5
  };
  if (stepMap[step]) {
    return stepMap[step];
  }
  if (isGlobale) {
    return 6;
  }
  return 7;
};
var formatCheckout = exports.formatCheckout = function formatCheckout(event) {
  var _event$context3 = event.context,
    currency = _event$context3.currency,
    currencyCode = _event$context3.currencyCode;
  var _event$data$ = event.data[0],
    step = _event$data$.step,
    basket = _event$data$.basket,
    type = _event$data$.type;
  var items = basket.items;
  var products = items.map(function (_ref) {
    var id = _ref.id,
      product = _ref.product,
      quantity = _ref.quantity,
      size = _ref.size,
      sku = _ref.sku;
    return {
      id: id,
      sku: sku,
      product: product,
      quantity: quantity,
      size: size
    };
  });
  var isGlobale = type === 'checkout-globale';
  return {
    ecommerce: {
      currencyCode: currency || currencyCode,
      checkout: {
        actionField: {
          step: transferStepToInteger(step, isGlobale),
          stepName: isGlobale ? 'checkout-globale' : step
        },
        products: (0, _formatProduct["default"])(products)
      }
    }
  };
};
var formatProductClick = exports.formatProductClick = function formatProductClick(data) {
  var productClickData = data;
  var actionField = productClickData.ecommerce.click.actionField;
  localStorage.setItem('list', actionField.list);
  productClickData.ecommerce.click.actionField = _objectSpread({
    type: undefined,
    contentId: undefined,
    eventId: undefined
  }, actionField);
  return productClickData;
};
var formatwishlistInteraction = exports.formatwishlistInteraction = function formatwishlistInteraction(data) {
  return {
    wishlist: _objectSpread({
      contentId: undefined,
      eventId: undefined
    }, data.wishlist)
  };
};